"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TreeViewItem = void 0;
var _react = _interopRequireWildcard(require("react"));
var _react2 = require("@iconify/react");
var _ChevronRight = _interopRequireDefault(require("@mui/icons-material/ChevronRight"));
var _ExpandMore = _interopRequireDefault(require("@mui/icons-material/ExpandMore"));
var _FolderOpenOutlined = _interopRequireDefault(require("@mui/icons-material/FolderOpenOutlined"));
var _InsertDriveFileOutlined = _interopRequireDefault(require("@mui/icons-material/InsertDriveFileOutlined"));
var _SubdirectoryArrowRight = _interopRequireDefault(require("@mui/icons-material/SubdirectoryArrowRight"));
var _material = require("@mui/material");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var TreeViewItem = exports.TreeViewItem = function TreeViewItem(_ref) {
  var children = _ref.children,
    label = _ref.label,
    category = _ref.category,
    type = _ref.type,
    level = _ref.level,
    isChecked = _ref.isChecked,
    isIndeterminate = _ref.isIndeterminate,
    onCheckboxChange = _ref.onCheckboxChange;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isExpanded = _useState2[0],
    setIsExpanded = _useState2[1];
  var showIcon = type === "folder";
  var hasChildren = Boolean(children);
  var handleToggle = function handleToggle() {
    if (showIcon) {
      setIsExpanded(!isExpanded);
    }
  };
  var handleCheckboxChange = function handleCheckboxChange(event) {
    onCheckboxChange(event.target.checked);
  };
  var absoluteLeftRight = level > 0 ? level : level * -8;
  var blockPadding = "0 4px";
  return /*#__PURE__*/_react["default"].createElement(_material.Box, {
    display: "flex",
    flexDirection: "column",
    sx: {
      position: "relative",
      width: "100%"
    },
    gap: 1
  }, /*#__PURE__*/_react["default"].createElement(_material.Box, {
    sx: {
      backgroundColor: isChecked || isIndeterminate ? "#F5F5F5" : "transparent",
      position: "absolute",
      top: 0,
      left: absoluteLeftRight,
      right: absoluteLeftRight,
      height: "21px",
      borderRadius: "8px",
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      paddingRight: "8px"
    }
  }, category && (category === null || category === void 0 ? void 0 : category.length) > 0 && /*#__PURE__*/_react["default"].createElement(_react2.Icon, {
    icon: "akar-icons:check",
    height: 20,
    style: {
      color: "green"
    }
  })), /*#__PURE__*/_react["default"].createElement(_material.Box, {
    display: "flex",
    alignItems: "center"
  }, /*#__PURE__*/_react["default"].createElement(_material.Box, {
    width: "".concat(level > 1 ? 29 * level : 0, "px")
  }), level !== 0 && /*#__PURE__*/_react["default"].createElement(_material.Box, {
    sx: {
      zIndex: 1,
      padding: blockPadding,
      display: "flex",
      alignItems: "center"
    }
  }, /*#__PURE__*/_react["default"].createElement(_SubdirectoryArrowRight["default"], {
    sx: {
      color: "grey.500"
    }
  })), /*#__PURE__*/_react["default"].createElement(_material.Checkbox, {
    checked: isChecked,
    indeterminate: isIndeterminate,
    sx: {
      padding: blockPadding
    },
    onChange: function onChange(e) {
      e.stopPropagation();
      handleCheckboxChange(e);
    }
  }), showIcon && /*#__PURE__*/_react["default"].createElement(_material.IconButton, {
    size: "small",
    onClick: handleToggle,
    sx: {
      padding: blockPadding
    }
  }, isExpanded ? /*#__PURE__*/_react["default"].createElement(_ExpandMore["default"], null) : /*#__PURE__*/_react["default"].createElement(_ChevronRight["default"], null)), /*#__PURE__*/_react["default"].createElement(_material.Box, {
    sx: {
      zIndex: 1,
      padding: blockPadding,
      display: "flex",
      alignItems: "center"
    }
  }, type === "folder" && /*#__PURE__*/_react["default"].createElement(_FolderOpenOutlined["default"], null), type === "file" && /*#__PURE__*/_react["default"].createElement(_InsertDriveFileOutlined["default"], null)), /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    sx: {
      zIndex: 1,
      fontWeight: isChecked || isIndeterminate ? "600" : "400"
    }
  }, label)), hasChildren && isExpanded && /*#__PURE__*/_react["default"].createElement(_material.Box, {
    display: "flex",
    alignItems: "flex-start",
    flexDirection: "column",
    gap: 1,
    sx: {
      width: "100%"
    }
  }, children));
};